// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const rawEnvUrl = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_URL = (rawEnvUrl && !rawEnvUrl.includes("sgfuzehpgggswdtlyksp"))
  ? rawEnvUrl
  : "https://nrvabhnisfqhmdomqhsg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5ydmFiaG5pc2ZxaG1kb21xaHNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTA1NTY2NDAsImV4cCI6MjEwNjEzMjY0MH0.xFFKKAmX6E9zvrZDdbEznemS7MgwYxg_zh6dweywEmU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});
